import { AdminGeofences } from '../model/admin-geofences';
export class AdminGeofencesBuilder {
    static buildAdminGeofences(data) {
        let adminGeofence = new AdminGeofences();
        adminGeofence.id = data.id;
        adminGeofence.id_product = data.id_product;
        adminGeofence.id_terminal = data.id_terminal;
        adminGeofence.mode = data.mode;
        adminGeofence.lat = data.lat;
        adminGeofence.lng = data.lng;
        adminGeofence.radius = data.radius;
        adminGeofence.prediction = data.prediction;
        adminGeofence.name = data.name;
        adminGeofence.speed_limit = data.speed_limit;
        return adminGeofence;
    }
}
//# sourceMappingURL=admin-geofences-builder.js.map